import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {Link as Link1} from 'react-scroll'

import brandIcon from '../assets/images/icon.png'
import appstore from '../assets/images/appstore.png'
import playstore from '../assets/images/playstore.png'

import {FiUser} from 'react-icons/fi'
import { FaWhatsapp } from 'react-icons/fa'

export default function Navbar({navLight, playBtn, bgLight, navCenter} : {navLight:boolean, playBtn:boolean, bgLight:boolean, navCenter:boolean}) {
    let [menu, setMenu] = useState<Boolean>(false);
    let [scroll, setScroll] = useState<Boolean>(false)
    const whatsappMessage = encodeURIComponent('Hola, quiero agendar una demo de Therapy Connect.');
    const whatsappUrl = `https://wa.me/?text=${whatsappMessage}`;

    useEffect(()=>{

        const handlerScroll=()=>{
            if(window.scrollY > 50){
                setScroll(true)
            }else{setScroll(false)}
        }

        window.addEventListener('scroll',handlerScroll)
        return () => {
        window.removeEventListener('scroll',handlerScroll)
        };
    })

  return (
    <>
        <nav className={`navbar ${bgLight ? 'bg-white dark:bg-slate-900 shadow dark:shadow-gray-800' : ''} ${scroll ? 'is-sticky' : '' }`} id="navbar">
            <div className="container relative flex flex-wrap items-center justify-between">
                <Link className="navbar-brand md:me-8 text-xl font-bold inline-flex items-center gap-3" to="/">
                    <span className="h-11 w-11 rounded-xl bg-white/80 border border-slate-200 shadow-sm inline-flex items-center justify-center overflow-hidden dark:bg-slate-800 dark:border-slate-700">
                        <img src={brandIcon} className="h-9 w-9 object-cover rounded-lg" alt="Therapy Connect" />
                    </span>
                    <span>Therapy Connect</span>
                </Link>

                <div className="nav-icons flex items-center lg_992:order-2 md:ms-6">
                    {!playBtn && 
                        <ul className="list-none menu-social mb-0">
                            <li className="inline">
                                <Link to="" className="size-8 inline-flex items-center justify-center rounded-full align-middle bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white"><FiUser className="size-4"/></Link>
                            </li>
                            <li className="inline">
                                                                <a
                                                                    href={whatsappUrl}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="h-8 px-4 text-[12px] tracking-wider inline-flex items-center justify-center font-medium rounded-full bg-red-500 text-white uppercase"
                                                                >
                                                                    Contacto
                                                                </a>
                            </li>
                        </ul>
                    }
                    {playBtn && 
                        <ul className="list-none menu-social mb-0">
                            <li className="inline">
                                <Link to="" className="size-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center"><img src={appstore} alt=""/></Link>
                            </li>

                            <li className="inline ms-1">
                                <Link to="" className="size-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center"><img src={playstore} alt=""/></Link>
                            </li>
                        </ul>
                    }
                    <button type="button" className="collapse-btn inline-flex items-center ms-2 text-slate-900 dark:text-white lg_992:hidden" onClick={() => setMenu(!menu)}>
                        <span className="sr-only">Navigation Menu</span>
                        <i className="mdi mdi-menu text-[24px]"></i>
                    </button>
                </div>

                <div className={`navigation lg_992:order-1 lg_992:flex  ${navCenter ? '' : 'ms-auto'} ${menu ? '' : 'hidden'}`} id="menu-collapse">
                    <ul className={`navbar-nav ${navLight ? 'nav-light' : ''}`} id="navbar-navlist">
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="home">Inicio</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="features">Funciones</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="screenshot">Aplicación</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="faqs">Preguntas</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="download">Descarga</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="reviews">Testimonios</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="contact">Contacto</Link1>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Contacto por WhatsApp"
                    className="fixed bottom-20 end-6 z-50 size-14 rounded-full bg-red-500 text-white shadow-lg inline-flex items-center justify-center hover:bg-red-500"
                >
                    <FaWhatsapp className="size-7" />
                </a>
        </>
    )
}
